export const ROOT = "/quantlab-function-library";
export const FILE = `${ROOT}/:keyword/:filename`;
